<template>
    <div class="view view--login">
        <div class="has-margin-b30 has-margin-t30">
            <control
                name="emailControl"
                type="text"
                v-bind:label="__('Email')"
                v-model="email"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.email != null"
            >
                {{ errors.email[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="passwordControl"
                type="password"
                v-bind:label="__('Password')"
                v-model="password"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.password != null"
            >
                {{ errors.password[0] }}
            </div>
        </div>

        <btn type="default" v-html="__('Login')" v-on:click="checkLogin"></btn>
    </div>
</template>

<script>
import store from '../../store';
import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import AuthRepository from '../../repositories/AuthRepository';
import router from '../../router';
import MessageHandler from '../../messageHandler';

export default {
    components: {
        Btn,
        Control
    },
    created: function() {
        this.autRepository = new AuthRepository();

        if (store.state.userToken !== '') {
            this.toPrograms();
        }
    },
    data: function() {
        return {
            email: '',
            errors: {},
            password: '',
            autRepository: null
        };
    },
    methods: {
        checkLogin: async function() {
            try {
                const response = await this.autRepository.login(
                    this.email,
                    this.password
                );
                store.commit('login', {
                    user: response.user,
                    userToken: response.token
                });

                this.toPrograms();
            } catch (error) {}
        },
        toPrograms: function() {
            router.push({
                path: '/programs'
            });
        }
    }
};
</script>
